import reducer from "./reducer";
export { default as PublicationSettings } from "./components/index";
export { default as publicationSettingsReducerName } from "./constants";
export default reducer;
